import { makeStyles } from '@bymason-private/controller-v1-theme-provider';
import { Box, Text } from '@bymason-private/legacy-pattern-components';

const useStyles = makeStyles(() => ({
  logoContainer: {
    width: '100%',
    backgroundColor: 'white',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: 20,
    '& > img': {
      width: 'auto',
      height: 58,
      marginBottom: 12,
    },
  },
  logoText: {
    fontSize: 22,
    lineHeight: '30px',
  },
}));

export const ControllerLogo = () => {
  const classes = useStyles();

  return (
    <Box className={classes.logoContainer}>
      <img alt='' src='https://mcdn.bymason.com/mason_logo.png' />
      <Text className={classes.logoText} title='Controller'>
        Controller
      </Text>
    </Box>
  );
};
